export const LOCAL_DATE_FORMAT = "DD.MM.YYYY";
export const LAST_STREAMS_COUNT = 6;

export const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/channel/UCsk8HZwh7lrhs627Qejy3Ww";
export const TWITCH_CHANNEL_URL = "https://www.twitch.tv/boodkafm/about";
export const INSTAGRAM_CHANNEL_URL = "https://www.instagram.com/boodkafm/";
export const DONATION_URL = "https://www.donationalerts.com/r/boodkafm";
